import interceptor from "../common/interceptor";
import { APIPaths } from "../common/constants";

// API call for home page USER TASKS
export const GetUserTask = (token) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosGet("Get", APIPaths.button_status, token, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error?.response?.data?.error", error?.response);
            reject(error?.response);
        })
    });
};
// API call for shipment chart
export const GetShipmentChart = (token,model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosPost("Post", APIPaths.shipment_chart, model, token)
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                console.log("Error fetching Shipment Chart:", error?.response);
                reject(error?.response);
            });
    });
};


// API call for Right time  chart [mahtab]
export const GetRightTimeChart = (token,model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosPost("Post", APIPaths.right_Time_chart, model, token)
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                console.log("Error fetching Shipment Chart:", error?.response);
                reject(error?.response);
            });
    });
};

// API call for shipment chart [mahtab]
export const GetAverageTimeChart = (token,model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosPost("Post", APIPaths.average_chart, model, token)
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                console.log("Error fetching Shipment Chart:", error?.response);
                reject(error?.response);
            });
    });
};
// API call foron time chart
export const GetOntimeChart = (token,model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosPost("Post", APIPaths.ontime_chart, model, token)
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                console.log("Error fetching Ontime Chart:", error?.response);
                reject(error?.response);
            });
    });
};

// API call for shipment chart
export const GetHomeMapFilterProducts = (token,model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosPost("Post", APIPaths.home_map_filter, model, token)
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                console.log("Error fetching Shipment Chart:", error?.response);
                reject(error?.response);
            });
    });
};
export const GetHomeLocations = (token,model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosPost("Post", APIPaths.shipment_locations, model, token)
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                console.log("Error fetching Shipment Chart:", error?.response);
                reject(error?.response);
            });
    });
};

// // API call for home page SHIPMENT ALL LOCATIONS
// export const GetHomeLocations = (token) => {
//     return new Promise((resolve, reject) => {
//         interceptor.axiosGet("Get", APIPaths.shipment_locations, token, null).then(res => {
//             resolve(res);
//         }).catch(error => {
//             console.log("error?.response?.data?.error", error?.response);
//             reject(error?.response);
//         })
//     });
// };



// export const GetHomeMapFilterProducts = (token, id) => {
//     console.log('iddd' , id)
//     return new Promise((resolve, reject) => {
//         interceptor.axiosGet("Get", APIPaths.home_map_filter+'?product_id='+id, token,null
            
//         ).then(res => {
//             resolve(res);
//         }).catch(error => {
//             console.log("error?.response?.data?.error", error?.response);
//             reject(error?.response);
//         })
//     });
// };

// get news flash card data 

export const GetNewsFlash = (token) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosGet("Get", APIPaths.home_news_flash, token, null).then(res => {
            resolve(res);
        }).catch(error => {
            console.log("error fetching news flash", error?.response);
            reject(error?.response);
        })
    });
};

// API call for add/edit metrics [mahtab]
export const sendtMetrics = (token, model) => {
    return new Promise((resolve, reject) => {
        interceptor.axiosPost("Post", APIPaths.home_target_metrics, model, token)
            .then(res => {
                resolve(res);
            })
            .catch(error => {
                console.log("Error while posting Chart metrics:", error?.response);
                reject(error?.response);
            });
    });
};

// export const GetSingleShipment = (token, id) => {
//     return new Promise((resolve, reject) => {
//         interceptor.axiosGet("Get", APIPaths.shipments + id + "/", token, null).then(res => {
//             resolve(res);
//         }).catch(error => {
//             console.log("error?.response?.data?.error", error?.response);
//             reject(error?.response);
//         })
//     });
// };



// //Call For Add new Shipment [by Nisha]

// export const CreateNewShipment = (token, model) => {
//     return new Promise((resolve, reject) => {
//         interceptor.axiosPost("Post", APIPaths.addNewShipment, model, token).then(res => {
//             resolve(res);
//         }).catch(error => {
//             console.log("error?.response?.data?.error", error?.response);
//             reject(error?.response);
//         })
//     });
// };



// //Call For Add new Shipment [by Nisha]

// export const GetShipmentByID = (token, id) => {
//     const url = `${APIPaths.addNewShipment}${id}/`;
//     return new Promise((resolve, reject) => {
//         interceptor.axiosGet("Get", url, token, null).then(res => {
//             resolve(res);
//         }).catch(error => {
//             console.log("error?.response?.data?.error", error?.response);
//             reject(error?.response);
//         })
//     });
// };







// //Api for bulk upload
// export const UploadShipmentFile = (token, model) => {
//     return new Promise((resolve, reject) => {
//         interceptor.axiosPostForUpload("Post", APIPaths.uploadBulkShipment, model, token).then(res => {
//             resolve(res);
//         }).catch(error => {
//             console.log("error?.response?.data?.error", error?.response);
//             reject(error?.response);
//         })
//     });
// };



// export const ArchiveShipment = (id,token) =>{
//     const url = `${APIPaths.shipment_archive}`;
//     return new Promise((resolve, reject) => {
//         interceptor.axiosDelete("Delete", url,id, token).then(res => {
//             resolve(res);
//         }).catch(error => {
//             console.log("error?.response?.data?.error", error?.response);
//             reject(error?.response);
//         })
//     });
// }